import { IconButton } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useSearchToggleStyles } from './search-toggle.styles';

export interface SearchToggleProps {
  isOpen: boolean;
  onToggle: (open: boolean) => void;
}

export function SearchToggle(props: SearchToggleProps) {
  const classes = useSearchToggleStyles();
  return (
    <IconButton
      classes={{ root: classes.iconButton }}
      onClick={() => props.onToggle(!props.isOpen)}
      aria-label="search"
      size="medium"
    >
      <Search className={classes.icon} />
    </IconButton>
  );
}
